import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { AvailableAccounts } from '@app/modules/businesses/models/statements.models';
import { StatementsAccountingIntegrationService } from '@app/modules/statements/services/statements-accounting-integration.service';
import { Observable } from 'rxjs';
import { filter, map, shareReplay, tap } from 'rxjs/operators';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'sbnb-statements-accounting-connection-form-map-accounts',
  templateUrl: './statements-accounting-connection-form-map-accounts.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class StatementsAccountingConnectionFormMapAccountsComponent implements OnInit {
  public formState$ = this.statementsAccountingIntegrationService.formState$.pipe(
    filter((state) => state.data !== null)
  );

  groupedAccountsToMap$ = this.formState$.pipe(
    map((state) =>
      Object.entries(state.data.accounts.fieldMap).reduce(
        (acc, [reference, field]) => ({
          ...acc,
          [field.category]: [...(acc[field.category] ?? []), { reference, ...field }],
        }),
        {}
      )
    )
  );

  accountsOptions$: Observable<AvailableAccounts> = this.formState$.pipe(
    map((state) => state.data.accounts.options as unknown as AvailableAccounts),
    shareReplay(1)
  );

  constructor(
    private statementsAccountingIntegrationService: StatementsAccountingIntegrationService,
    public form: FormGroupDirective
  ) {}

  ngOnInit(): void {}

  compareCategories(a: KeyValue<string, any[]>, b: KeyValue<string, any[]>): number {
    const order = ['assets', 'liabilities', 'income', 'expenses'];
    return order.indexOf(b.key) - order.indexOf(a.key);
  }
}
